module.exports = __webpack_public_path__ + "img/johnny.c5f2df65.jpg";